<ng-container *ngIf="inputType === 'Slider'">
  <slider [inputId]="inputId" [inputIndex]="inputIndex" [projectId]="projectId"></slider>
</ng-container>
<ng-container *ngIf="inputType === 'Yes or no question'">
  <yes-or-no-question [inputId]="inputId" [inputIndex]="inputIndex" [projectId]="projectId"></yes-or-no-question>
</ng-container>
<ng-container *ngIf="inputType === 'Multiple choice question'">
  <multiple-choice-question [inputId]="inputId" [inputIndex]="inputIndex" [projectId]="projectId"></multiple-choice-question>
</ng-container>
